import { render, staticRenderFns } from "./ProductListBlock.vue?vue&type=template&id=e4d70946&"
import script from "./ProductListBlock.vue?vue&type=script&lang=ts&"
export * from "./ProductListBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports